var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bindEmail"},[(_vm.show)?_c('noBindEmail',{on:{"showLast":_vm.parentShow}}):_c('onBindEmail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }